export const ApprovalStepStatus = {
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  APPROVED: 'APPROVED',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  REJECTED: 'REJECTED',
  WAITING: 'WAITING'
};
export const AgentTurnType = {
  REVIEW: 'REVIEW',
  APPLY_CHANGES: 'APPLY_CHANGES'
};
// The operations the current viewer may take on a given step, as computed and
// returned by the backend per step in getLatestApproval. Mirrors the generated
// CHIRP ApprovalStepOperation union (declared locally because the common package
// cannot import the app's generated CHIRP types, same as ApprovalStepStatus).
export const ApprovalStepOperation = {
  APPROVE: 'APPROVE',
  REQUEST_CHANGES: 'REQUEST_CHANGES',
  REJECT: 'REJECT'
};